import styles from "./index.module.css";

interface Props {
  mobilePhone: string;
}

export const CzechMobilePhone = ({ mobilePhone }: Props) => {
  const phoneSplitBy3 = mobilePhone.match(/.{1,3}/g);
  const phoneSplitBy3Length = phoneSplitBy3?.length ?? 0;
  return (
    <span data-testid="czPhone" className={`${styles.format} piiData`}>
      <span>+420 </span>
      {phoneSplitBy3?.map((part, index) => (
        <span key={`${part}-${index}`}>
          <span className={styles.mobilePhone}>{part}</span>
          {index !== phoneSplitBy3Length - 1 && <> </>}
        </span>
      ))}
    </span>
  );
};
